import { createFileRoute, Navigate } from '@tanstack/react-router';
import { type ReactElement } from 'react';

import { automationDetailSearchSchema } from '@apps/web/components/automations/agent_configuration_search';
import { AutomationDetailPage } from '@apps/web/components/automations/customer/automation_detail_page';
import { useSettingsGates } from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/(main)/routines/$routineId')({
    validateSearch: automationDetailSearchSchema,
    head: () => ({
        meta: [{ title: 'Routine | Phoebe' }],
    }),
    component: RoutineDetailRoute,
});

export function RoutineDetailRoute(): ReactElement | null {
    const { routineId } = Route.useParams();
    const { organizationId, isLoading, gates } = useSettingsGates();

    if (isLoading) {
        return null;
    }
    if (!gates.canManageOrgSettings || !gates.coordinatorAutomations) {
        return <Navigate to="/home" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <AutomationDetailPage
            automationId={routineId}
            organizationId={organizationId}
        />
    );
}
